import axios from './axiosInstance';
import {Globals} from '../global/Globals';

export const getRecordsFromActivationLink=async(link)=>{
    const apiResponse = await axios.get(Globals.ENDPOINT.USER_RECORDS_FROM_ACT_LINK+link);
    return apiResponse;
}

export const activateAccount=async(producerId, password)=>{
    const config = {
        headers: {
          'Content-Type': 'application/json' // Set the Content-Type header
        }
      };
    const body=password;
    const apiResponse = await axios.put(Globals.ENDPOINT.ACTIVATE_ACCOUNT+producerId,body, config);
    console.log("apiResponse ==> ",apiResponse);
 return apiResponse;
}